import React, { useEffect, useState } from "react";

import {
  STATUS_PLATFORMTYPE_MIRAKL,
  SELECT,
} from "../../../../constants/Constants";
import { httpGetConfigValues } from "../../../../service/httpClient";

const DynamicOptions = ({
  labelName,
  responseValue,
  selectedValue,
  configValues,
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (configValues && configValues?.length > 0) {
      Object.values(configValues)
        .filter((res) => res.key.indexOf(labelName) > -1)
        .map((val) => {
          let selectOptions = JSON.parse(val.value);
          if (responseValue !== "MP") {
            selectOptions = selectOptions.filter((opt) => opt.name !== "MP");
          }
          if (labelName === "vendorConnectionPlatform") {
            selectOptions = selectOptions.filter(
              (opt) => !STATUS_PLATFORMTYPE_MIRAKL.includes(opt.name)
            );
          }
          if (selectedValue === "Both" && labelName === "merchandiseType") {
            selectOptions.push({
              name: "Both",
              value: "Both",
            });
          }
          setOptions(selectOptions);
        });
    }
  }, []);

  return (
    <>
      <option value="" selected disabled>
        {SELECT}
      </option>
      {options.map((option, index) => {
        let element = {};
        element = (
          <option
            key={index}
            value={option.name}
            selected={option.name == responseValue ? true : false}
          >
            {option.value}
          </option>
        );
        return element;
      })}
    </>
  );
};

export default DynamicOptions;
